import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ServiceInvoiceList from "./ServiceInvoiceList";
import {getServiceInvoiceList} from "services/redux/sales/postSales/action";

const mapStateToProps = (state) => ({
    valetContractInvoice: state.postSalesReducer.valetContractInvoice,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getServiceInvoiceList
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ServiceInvoiceList);
